<form [formGroup]="form" class="formgrid grid">
    <div class="field col-12">
      <label for="titleInput">Anrede<ow-validation-mark [control]="form.controls.title"></ow-validation-mark></label>
      <p-dropdown
        inputId="titleInput"
        formControlName="title"
        [options]="TITLE_OPTIONS"
        placeholder="Anrede"
        styleClass="w-full"
      ></p-dropdown>
    </div>
    <div class="field col-12">
      <label for="firstNameInput"
        >Vorname<ow-validation-mark [control]="form.controls.firstName"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="firstNameInput" formControlName="firstName" class="w-full" />
    </div>
    <div class="field col-12">
      <label for="lastNameInput"
        >Nachname<ow-validation-mark [control]="form.controls.lastName"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="lastNameInput" formControlName="lastName" class="w-full" />
    </div>
    <div class="field col-12">
      <label for="birthDateInput"
        >Geburtsdatum<ow-validation-mark [control]="form.controls.birthDate"></ow-validation-mark
      ></label>
      <p-calendar id="birthDateInput" formControlName="birthDate" styleClass="w-full"></p-calendar>
    </div>
    <div class="field col-12">
      <label for="phoneNumberInput"
        >Telefonnummer<ow-validation-mark [control]="form.controls.phoneNumber"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="phoneNumberInput" formControlName="phoneNumber" class="w-full" />
    </div>
</form>
